import { $http } from "@/assets/js/appFunc";
import { TASK_DEFAULTS } from "@/components/tasks/const/myTasks";
import { convertProductivityData } from "./helpers";

export const getTasksList = (store, payload) => {
    $http({
        url: "/engine/tasks/list",
        type: "POST",
        data: payload
    }, true).then(rsp => {
        store.commit("setTasksList", rsp.data);
    });
};
export const getStatsProductivity = (store, payload) => {
    let url = "/stats/api/productivity/yesterday";
    if (payload) {
        url = `/stats/api/team/productivity/yesterday/${payload}/false`;
    }
    return new Promise((resolve) => {
        $http({
            url,
            type: "GET"
        }, true).then(rsp => {
            resolve(rsp.data);
        }).catch(e => {
            console.log(e);
        });
    });
};
export const getTasksStatus = (store) => {
    $http({
        url: `/engine/dashboard/task/statistics?isTeam=${TASK_DEFAULTS.isTeam}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksStatus", rsp.data);
    }).catch(() => {
        // TODO error handling
    });
};

export const getTaskForTeam = (store, groupId) => {
    $http({
        url: `/engine/task/infoByTeam/${groupId}/false`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksStatus", rsp.data);
    }).catch(e => {
        console.log(e);
    });
};

export const getTasksOverview = (store, { fromDate, toDate }) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/interval?fromDate=${fromDate}&toDate=${toDate}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});
export const getProductivityData = (store, { timeFrame = "weeks", compare = "CURRENT" } = {}) => new Promise((resolve, reject) => {
    $http({
        url: `/stats/api/productivity/by/${timeFrame}/${compare}`,
        type: "GET",
        data: ""
    }, true).then(resp => {
        const series = convertProductivityData(resp.data, timeFrame);
        resolve(series);
    }).catch(error => {
        reject(error);
    });
});
export const getTeamProductivityData = (store, {
    timeFrame = "weeks", compare = "CURRENT", primary = { id: null, type: null }, secondary = null
} = {}) => {
    const data = {
        primary: {
            id: primary.id,
            type: primary.type.toUpperCase()
        },
        timeFrame: compare,
        withManager: false
    };
    if (secondary) {
        data.secondary = {
            id: secondary.id1,
            type: secondary.type1.toUpperCase()
        };
    }
    return new Promise((resolve, reject) => {
        $http({
            url: `/stats/api/productivity/team/by/${timeFrame}`,
            type: "POST",
            data
        }, true).then(resp => {
            const series = convertProductivityData(resp.data, timeFrame);
            resolve(series);
        }).catch(error => {
            reject(error);
        });
    });
};
export const getTasksOverviewWeek = (store, week) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/weeks/${week}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});
export const getTasksOverviewMonth = (store, month) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/months/${month}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});
export const getTasksOverviewQuarter = (store, quarter) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/quarter/${quarter}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});
export const getTasksOverviewSemester = (store, semester) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/semester/${semester}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});
export const getTasksOverviewYear = (store, year) => new Promise((resolve) => {
    $http({
        url: `/engine/dashboard/task/statistics/by/year/${year}`,
        type: "GET",
        data: ""
    }, true).then(rsp => {
        store.commit("setTasksOverview", rsp.data);
        resolve(rsp.data);
    }).catch(() => {
        // err handling todo
    });
});

export const getDashboardCustomization = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/customization",
        data: payload
    };
    return $http(req, true);
};

export const saveDashboardCustomization = (context, payload) => {
    const req = {
        type: "PUT",
        url: "/identity/customization",
        data: payload
    };
    return $http(req, true);
};

export const resetDashboardCustomization = (context, payload) => {
    const req = {
        type: "PUT",
        url: "/identity/customization/reset",
        data: payload
    };
    return $http(req, true);
};
